// VortexShake — scripts propios (vanilla JS, sin dependencias externas)
document.addEventListener('DOMContentLoaded', () => {
  initReveal();
  initCifras();
  initGaleriaProducto();
  initVariantes();
  initCantidad();
  initFaq();
  initScrollResenas();
  initCuentaRegresiva();
});

function initCuentaRegresiva() {
  document.querySelectorAll('[data-mt-cuenta-regresiva]').forEach((barra) => {
    const fin = new Date(barra.getAttribute('data-fin')).getTime();
    const textoExpirado = barra.getAttribute('data-texto-expirado') || '';
    const numeros = barra.querySelectorAll('[data-mt-cr-numero]');
    if (!fin || Number.isNaN(fin)) {
      barra.hidden = true;
      return;
    }

    function actualizar() {
      const restante = fin - Date.now();
      if (restante <= 0) {
        if (textoExpirado) {
          barra.querySelector('[data-mt-cr-contenido]').hidden = true;
          const expirado = barra.querySelector('[data-mt-cr-expirado]');
          if (expirado) expirado.hidden = false;
        } else {
          barra.hidden = true;
        }
        clearInterval(intervalo);
        return;
      }
      const dias = Math.floor(restante / 86400000);
      const horas = Math.floor((restante % 86400000) / 3600000);
      const minutos = Math.floor((restante % 3600000) / 60000);
      const segundos = Math.floor((restante % 60000) / 1000);
      const partes = { dias, horas, minutos, segundos };
      numeros.forEach((el) => {
        const unidad = el.getAttribute('data-mt-cr-numero');
        el.textContent = String(partes[unidad]).padStart(2, '0');
      });
    }

    actualizar();
    const intervalo = setInterval(actualizar, 1000);
  });
}

function initScrollResenas() {
  document.querySelectorAll('[data-mt-ir-a-resenas]').forEach((el) => {
    el.addEventListener('click', (evt) => {
      const destino = document.querySelector('[data-mt-resenas]');
      if (!destino) return;
      evt.preventDefault();
      destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

function initReveal() {
  const els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach((el) => io.observe(el));
}

function initCifras() {
  const els = document.querySelectorAll('.mt-cifra[data-hasta]');
  if (!els.length) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const anima = (el) => {
    const hasta = parseFloat(el.dataset.hasta) || 0;
    const decimales = el.dataset.decimales ? parseInt(el.dataset.decimales, 10) : 0;
    if (reduce) {
      el.textContent = hasta.toFixed(decimales);
      return;
    }
    const duracion = 1400;
    const inicio = performance.now();
    const paso = (ahora) => {
      const t = Math.min((ahora - inicio) / duracion, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      el.textContent = (hasta * eased).toFixed(decimales);
      if (t < 1) requestAnimationFrame(paso);
    };
    requestAnimationFrame(paso);
  };
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          anima(entry.target);
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );
  els.forEach((el) => io.observe(el));
}

function initGaleriaProducto() {
  const galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach((galeria) => {
    const principal = galeria.querySelector('[data-mt-imagen-principal]');
    const minis = galeria.querySelectorAll('[data-mt-mini]');
    if (!principal || !minis.length) return;
    minis.forEach((mini) => {
      mini.addEventListener('click', () => {
        const src = mini.dataset.src;
        const srcset = mini.dataset.srcset;
        if (!src) return;
        principal.src = src;
        if (srcset) principal.srcset = srcset;
        minis.forEach((m) => m.classList.remove('mt-mini--activa'));
        mini.classList.add('mt-mini--activa');
      });
    });
  });
}

function initVariantes() {
  const forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach((form) => {
    const dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    let variantes = [];
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    const contenedor = form.closest('[data-mt-producto]') || form;
    const inputId = form.querySelector('input[name="id"]');
    const precioEl = contenedor.querySelector('[data-mt-precio]');
    const precioCompareEl = contenedor.querySelector('[data-mt-precio-comparado]');
    const stockEl = contenedor.querySelector('[data-mt-stock]');
    const stockTextoEl = contenedor.querySelector('[data-mt-stock-texto]');
    const stockUmbral = parseInt(form.dataset.stockUmbral, 10) || 15;
    const botonComprar = form.querySelector('[data-mt-comprar]');
    const opciones = form.querySelectorAll('[data-mt-opcion]');
    const galeria = contenedor.querySelector('[data-mt-galeria]');

    function moneda(centavos) {
      const divisa = form.dataset.moneda || 'USD';
      try {
        return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
          style: 'currency',
          currency: divisa,
        });
      } catch (e) {
        return (centavos / 100).toFixed(2) + ' ' + divisa;
      }
    }

    function actualizar() {
      const seleccion = Array.from(opciones).map((grupo) => {
        const activo = grupo.querySelector('.mt-opcion--activa');
        return activo ? activo.dataset.mtValor : null;
      });
      const variante = variantes.find((v) => v.options.every((val, i) => val === seleccion[i]));
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = moneda(variante.price);
      if (precioCompareEl) {
        if (variante.compare_at_price > 0 && variante.compare_at_price > variante.price) {
          precioCompareEl.textContent = moneda(variante.compare_at_price);
          precioCompareEl.hidden = false;
        } else {
          precioCompareEl.hidden = true;
        }
      }
      if (stockEl && stockTextoEl) {
        if (!variante.available) {
          stockEl.hidden = true;
        } else {
          stockEl.hidden = false;
          if (variante.inventory_quantity > 0 && variante.inventory_quantity <= stockUmbral) {
            stockEl.classList.add('mt-producto__stock--bajo');
            stockTextoEl.textContent = `Only ${variante.inventory_quantity} left in stock!`;
          } else {
            stockEl.classList.remove('mt-producto__stock--bajo');
            stockTextoEl.textContent = 'In stock, ready to ship';
          }
        }
      }
      if (botonComprar) {
        const span = botonComprar.querySelector('span');
        if (variante.available) {
          botonComprar.disabled = false;
          botonComprar.removeAttribute('aria-disabled');
          if (span) span.textContent = botonComprar.dataset.textoDisponible || span.textContent;
        } else {
          botonComprar.disabled = true;
          botonComprar.setAttribute('aria-disabled', 'true');
          if (span) span.textContent = botonComprar.dataset.textoAgotado || 'Sold out';
        }
      }
      if (variante.featured_image && galeria) {
        const principal = galeria.querySelector('[data-mt-imagen-principal]');
        if (principal) principal.src = variante.featured_image;
      }
    }

    opciones.forEach((grupo) => {
      grupo.querySelectorAll('[data-mt-valor]').forEach((btn) => {
        btn.addEventListener('click', () => {
          grupo.querySelectorAll('[data-mt-valor]').forEach((b) => b.classList.remove('mt-opcion--activa'));
          btn.classList.add('mt-opcion--activa');
          actualizar();
        });
      });
    });
  });
}

function initCantidad() {
  const contenedores = document.querySelectorAll('.mt-producto__cantidad');
  contenedores.forEach((cont) => {
    const input = cont.querySelector('[data-mt-cant-input]');
    const menos = cont.querySelector('[data-mt-cant-menos]');
    const mas = cont.querySelector('[data-mt-cant-mas]');
    if (!input) return;
    if (menos) menos.addEventListener('click', () => {
      const actual = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, actual - 1);
    });
    if (mas) mas.addEventListener('click', () => {
      const actual = parseInt(input.value, 10) || 1;
      input.value = actual + 1;
    });
  });
}

function initFaq() {
  const items = document.querySelectorAll('[data-mt-faq-pregunta]');
  items.forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('[data-mt-faq-item]');
      const abierto = item.classList.contains('mt-faq-item--abierta');
      item.parentElement.querySelectorAll('[data-mt-faq-item]').forEach((i) => i.classList.remove('mt-faq-item--abierta'));
      if (!abierto) item.classList.add('mt-faq-item--abierta');
    });
  });
}
